

import axios from "axios";
import router from "./../router/index";
import CONFIG from "./../index";
import Permission from "../http/permission";
import Api from "../http/api";
// import { Message } from "element-ui";
import hexMd5 from "js-md5";
// import ar from "element-ui/src/locale/lang/ar";
const Qs = require("qs");
// 创建axios实例
const axiosInstance = axios.create();
// 设置请求头
axiosInstance.defaults.headers.post["Content-Type"] = "application/json";
const appAlgorithm = "jwt/md5/extract";
const app = CONFIG;
// console.log(app, "app");
// 解析计算签名值
const extract = function(str) {
  let code = "";
  for (let i = 0; i < 5; ++i) {
    const pos = 2 << i;
    code += str.substring(pos - 1, pos);
  };
  return code;
};

const toLogin = () => {
  window.sessionStorage.clear();
  let params = {
    contentActiveIndex: 0, //只有一个场所的情况下代表内容index,多个场所的情况下代表场所index
    contentItemActiveIndex: 0, //多个场所的情况下代表内容index
    contentList: [],
    locations: [
      {
        address: "",
        longitude: "",
        latitude: "",
      },
    ],
    cardType: "", //0为卡片只有一个场所情况  1为卡片有多个场所情况
    batchId: "", //批次id
    cityCode: "", //城市code
    cityTaskId: null, //城市任务id
    status: null, //城市任务状态
    questionnaireStatus: null,
    groupId: null, //考察组id
    choseItem: null, //被选择的考察内容
    citys: null, //考察城市集合
    cardPermitSubmit: null, //是否显示城市提交按钮
    questionnairePermitSubmit: null, //是否显示问卷提交按钮
    beginTime: null, //城市任务开始时间
    endTime: null, //城市任务结束时间
    searchAddress: null, //地图查询地址
  };
  // store.commit("reset", params);
  router.push({ name: "Login" });
};

axiosInstance.interceptors.request.use(
  (config) => {
    let uri = config.url;
    let originalUri = config.url;
    let permissionCode = uri;
    let apiCode;
    const array = uri.split("-");
    console.log(array);
    if (array.length > 1) {
      apiCode = array[1];
      permissionCode = array[0];
    }
    if (
      !Object.prototype.hasOwnProperty.call(
        Permission.permissions,
        permissionCode
      ) &&
      !Object.prototype.hasOwnProperty.call(Permission.permissions, config.url)
    ) {
      return config;
    }
    const permission = Permission.permissions[permissionCode];
    console.log(permission,permissionCode);
    if (array.length === 1) {
      apiCode = permission.code;
    }
    const api = Api.api[apiCode];
    uri = api.uri;
    if (Object.prototype.hasOwnProperty.call(api, "path")) {
      // 有路径参数，需要替换
      let paths = api.path;
      paths.forEach(function(parameter) {
        let value;
        if (config.params) {
          value = config.params[parameter];
          if (!api.retain) {
            delete config.params[parameter];
          }
        } else {
          value = config.data[parameter];
          if (!api.retain) {
            delete config.data[parameter];
          }
        }
        uri = uri.replace("{" + parameter + "}", value);
      });
    }
    config.headers["permission"] = permissionCode;
    console.log(config.headers["permission"])
    let tokenString;
    let currTime = new Date().getTime();
    if (originalUri == "login") {
      // 登录接口
      let username = config.data.account;
      let pass = config.data.pass;
      let salt = config.data.salt;
      delete config.data.pass;
      let accountMD5 = hexMd5(`${username}${hexMd5(pass)}`);
      tokenString = `${appAlgorithm}${app.appKey}${currTime}${username}${salt}${accountMD5}${app.appSecret}`;
      // console.log(tokenString, "tokenString");
    } else {

      // const token=localStorage.getItem("accessToken")
      // // const info = JSON.parse(sessionStorage.getItem("unInfo"));
      // config.headers["Authorization"] = token;

      const info = JSON.parse(sessionStorage.getItem("unInfo"));
      config.headers["token"] = info.accessToken;
      //config.headers["token"] = "000";
      const salt = JSON.parse(sessionStorage.getItem("salt"));
      tokenString = `${appAlgorithm}${app.appKey}${uri}${permissionCode}${info.accessToken}${currTime}${salt}${info.random}${app.appSecret}`;
      console.log(tokenString);
      // console.log(tokenString,"tokenString");
    }
    const headerMD5 = hexMd5(tokenString);
    const appSignature = extract(headerMD5);
    config.headers["signature"] = appSignature;
    config.headers["app"] = app.code;
    config.headers["algorithm"] = appAlgorithm;
    config.headers["stamp"] = currTime;
    config.url = app.host + uri;
    if (config.method === "get") {
      // 如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2
        config.paramsSerializer = function(params) {
          return Qs.stringify(params, { arrayFormat: "repeat" });
        };
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
export default {
  axiosInstance,
  install(Vue) {
    // 自定义一个dom属性
    // eslint-disable-next-line no-unused-vars
    let _vue;
    // 获取vue对象
    Vue.prototype.Loading_ = (e) => {
      _vue = e;
    };
    // 封装axios请求并自定义操作
    Vue.prototype.$json = (uri, params, config) => {
      return new Promise((resolve, reject) => {
        let permissionCode = uri;
        let apiCode;
        const array = uri.split(".");
        if (array.length > 1) {
          permissionCode = array[0];
          apiCode = array[1];
        }
        let permission = Permission.permissions[permissionCode];
        if (!permission) {
          reject({ code: 404, message: "尚未支持的权限" });
          return;
        }
        if (array.length === 1) {
          apiCode = permission.code;
        } else {
          // 判断是否在权限的依赖接口中
          if (permission.assist) {
            if (!permission.assist.includes(apiCode)) {
              reject({ code: 404, message: "该功能不支持调用该接口" });
              return;
            }
          }
        }
        const api = Api.api[apiCode];
        if (api.method === "get") {
          const cfg = { ...config };
          cfg.params = params;
          axiosInstance
            .get(uri, cfg)
            .then((response) => {
              switch (response.data.code) {
                case 410:
                  toLogin();
                  break;
                case 413:
                  toLogin();
                  break;
                case 415:
                  toLogin();
                  break;
                case 481:
                  toLogin();
                  break;
                case 486:
                  toLogin();
                  break;
                case 487:
                  toLogin();
                  break;
                case 488:
                  toLogin();
                  break;
                case 491:
                  toLogin();
                  break;
                case 492:
                  toLogin();
                  break;
                case 494:
                  toLogin();
                  break;
                case 496:
                  toLogin();
                  break;
                case 497:
                  toLogin();
                  break;
                case 498:
                  toLogin();
                  break;
                case 499:
                  toLogin();
                  break;
              }
              // if (response.data.code === 497) {
              //   toLogin();
              //   return;
              // }
              if (
                response.config.responseType === "arraybuffer" ||
                response.config.responseType === "blob" ||
                api.stream === 1
              ) {
                // 流数据
                resolve(response);
              } else {
                if (response.data.code) {
                  // 业务处理失败了
                  if (response.data.code !== -1) {
                    reject({
                      code: response.data.code,
                      message: response.data.message,
                    });
                  } else {
                    reject({
                      code: response.data.code,
                      message: response.data.message,
                      // message: "系统错误，请联系管理员",
                    });
                  }
                } else {
                  resolve(response.data.data);
                }
              }
            })
            .catch((e) => {
              // 0此处表示网络异常
              reject({ code: 0, message: e.message });
            });
        } else if (api.method === "post") {
          axiosInstance
            .post(uri, params, config)
            .then((response) => {
              if (response.data.code === 499) {
                reject({
                  code: 499,
                  message:
                    "操作系统后台，需要中央机关授权，请您与上级机构核实用户权限。",
                });
                return;
              }
              switch (response.data.code) {
                case 410:
                  toLogin();
                  break;
                case 413:
                  toLogin();
                  break;
                case 415:
                  toLogin();
                  break;
                case 481:
                  toLogin();
                  break;
                case 486:
                  toLogin();
                  break;
                case 487:
                  toLogin();
                  break;
                case 488:
                  toLogin();
                  break;
                case 491:
                  toLogin();
                  break;
                case 492:
                  toLogin();
                  break;
                case 494:
                  toLogin();
                  break;
                case 496:
                  toLogin();
                  break;
                case 497:
                  toLogin();
                  break;
                case 498:
                  toLogin();
                  break;
                case 499:
                  toLogin();
                  break;
              }
              if (response.responseType === "arraybuffer") {
                // 流数据
                resolve(response);
              } else {
                if (response.data.code) {
                  // 业务处理失败了
                  if (response.data.code !== -1) {
                    reject({
                      code: response.data.code,
                      message: response.data.message,
                    });
                  } else {
                    reject({
                      code: response.data.code,
                      message: "系统错误，请联系管理员",
                    });
                  }
                } else {
                  resolve(response.data.data);
                }
              }
            })
            .catch((e) => {
              // 0此处表示网络异常
              reject({ code: 0, message: e.message });
            });
        } else if (api.method === "put") {
          axiosInstance
            .put(uri, params)
            .then((response) => {
              switch (response.data.code) {
                case 410:
                  toLogin();
                  break;
                case 413:
                  toLogin();
                  break;
                case 415:
                  toLogin();
                  break;
                case 481:
                  toLogin();
                  break;
                case 486:
                  toLogin();
                  break;
                case 487:
                  toLogin();
                  break;
                case 488:
                  toLogin();
                  break;
                case 491:
                  toLogin();
                  break;
                case 492:
                  toLogin();
                  break;
                case 494:
                  toLogin();
                  break;
                case 496:
                  toLogin();
                  break;
                case 497:
                  toLogin();
                  break;
                case 498:
                  toLogin();
                  break;
                case 499:
                  toLogin();
                  break;
              }
              if (response.data.code) {
                console.log(response);
                if (response.data.code !== -1) {
                  reject({
                    code: response.data.code,
                    message: response.data.message,
                  });
                } else {
                  reject({
                    code: response.data.code,
                    message: "系统错误，请联系管理员",
                  });
                }
              } else {
                console.log(response);
                resolve(response.data.data);
              }
            })
            .catch((e) => {
              // 0此处表示网络异常
              reject({ code: 0, message: e.message });
            });
        } else if (api.method === "delete") {
          axiosInstance
            .delete(uri, { params: params })
            .then((response) => {
              switch (response.data.code) {
                case 410:
                  toLogin();
                  break;
                case 413:
                  toLogin();
                  break;
                case 415:
                  toLogin();
                  break;
                case 481:
                  toLogin();
                  break;
                case 486:
                  toLogin();
                  break;
                case 487:
                  toLogin();
                  break;
                case 488:
                  toLogin();
                  break;
                case 491:
                  toLogin();
                  break;
                case 492:
                  toLogin();
                  break;
                case 494:
                  toLogin();
                  break;
                case 496:
                  toLogin();
                  break;
                case 497:
                  toLogin();
                  break;
                case 498:
                  toLogin();
                  break;
                case 499:
                  toLogin();
                  break;
              }
              if (response.data.code) {
                if (response.data.code !== -1) {
                  reject({
                    code: response.data.code,
                    message: response.data.message,
                  });
                } else {
                  reject({
                    code: response.data.code,
                    message: "系统错误，请联系管理员",
                  });
                }
              } else {
                resolve(response.data.data);
              }
            })
            .catch((e) => {
              // 0此处表示网络异常
              reject({ code: 0, message: e.message });
            });
        } else if (api.method === "patch") {
          axiosInstance
            .patch(uri, params)
            .then((response) => {
              if (response.data.code === 497) {
                toLogin();
                return;
              }
              if (response.data.code) {
                // 业务处理失败了
                if (response.data.code !== -1) {
                  reject({
                    code: response.data.code,
                    message: response.data.message,
                  });
                } else {
                  reject({
                    code: response.data.code,
                    message: "系统错误，请联系管理员",
                  });
                }
              } else {
                resolve(response.data.data);
              }
            })
            .catch((e) => {
              // 0此处表示网络异常
              reject({ code: 0, message: e.message });
            });
        }
      });
    };
  },
};





// WEBPACK FOOTER //
// ./src/utils/request.js